import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';
import ngSanitize from 'angular-sanitize';

import SearchController from './SearchController';

import popupPreferences from '../../directives/popupPreferences';
import matchesMessage from '../../directives/matchesMessage';
import photoGallery from '../../directives/photoGallery';

import panel from '../../services';

export default angular.module('app.search', [uirouter, panel, popupPreferences, matchesMessage, photoGallery, ngSanitize])
    .config(routing)
    .controller('SearchController', SearchController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/search/index.js